module.exports = __webpack_public_path__ + "img/8c228ca6-6ff3-4e1a-ab1e-de7af6b21548.7ef408a3.jpg";